import "./CoverCard.less";
import YulanImg from '@/assets/cut-mix-detail/yulan.png'
export interface ICoverCardProps {
  url: string;
  style?: React.CSSProperties;
  active?: boolean;
  onClick: () => void;
  handleLook?: () => void;
}

const CoverCard: React.FC<ICoverCardProps> = (props) => {
  const { style, url, active, onClick, handleLook } = props;
  return (
    <>
      <div
        style={style}
        className={`cover-card ${active ? "active" : ""}`}
        >
        <div onClick={() => {
          onClick();
        }} className="img-wrapper">
          <img src={url} alt=""/>
        </div>
        {
          active && <div className="img-look" onClick={(e) => {
            e.preventDefault();
            handleLook();
          }}>
                <img className="yulan" src={YulanImg} alt=""/>
            </div>
        }
      </div>
    </>
  );
};

export default CoverCard;
